import { HttpParams } from '@angular/common/http';
import { AfterViewInit, Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { LocalStorageService } from '../../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { KieneTableService } from '../../../components/kiene-table/kiene-table.service';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { TierauswahlEvent } from './../../../../../projects/kiene-core/src/lib/components/gruppen/classes/gruppe';
import { Gruppe } from '../../../../../projects/kiene-core/src/lib/components/gruppen/classes/gruppe';
import { GruppeTier } from '../../../../../projects/kiene-core/src/lib/components/gruppe-tier/classes/gruppe-tier';
import { TierGeschlecht } from '../../../../../projects/kiene-core/src/lib/components/gruppe-tier/classes/tier-geschlecht';
import { StammdatenService } from '../../../../../projects/kiene-core/src/lib/components/stammdaten/stammdaten.service';

@Component({
    selector: 'kiene-gruppe-details',
    templateUrl: './gruppe-details.component.html',
    styleUrls: ['./gruppe-details.component.scss'],
})
export class GruppeDetailsComponent implements OnInit, AfterViewInit {
    itemsPerPage = 10;
    pageIndex = 0;
    offset = 0;
    suchString: string = null;
    totalRecords = 0;
    sortDirection = 'asc';
    sortColumn = 'geburtsdatum';

    isLoading = false;
    showNachladeButton = false;
    private restlicheGeladen = false;
    private identifikationErsteSeite: GruppeTier[] = [];

    @Input('gruppe') gruppe: Gruppe = new Gruppe();
    @Input('zeigeMedikation') zeigeMedikation = false;
    @Input('auswahl') auswahl = false;
    @Input('identifikation') identifikation = false;
    @Input('identifikationText') identifikationText = '';
    @Input('selectedTiere') selectedTiere: GruppeTier[] = [];
    @Input('anzahlTiereSollwert') anzahlTiereSollwert = 0;
    @Output('selectionChange') selectionChange = new EventEmitter<TierauswahlEvent>();

    ohrmarkeCtrl = new UntypedFormControl();
    geschlechtCtrl = new UntypedFormControl();
    alterTageCtrl = new UntypedFormControl();

    einstalldatumSelectCtrl = new UntypedFormControl();
    einstalldaten: any[] = [];
    einstalldatum: Date;

    tiere: GruppeTier[] = [];
    selected: GruppeTier[] = [];
    numberSelected = 0;

    selectedAll = false;
    geschlechter: TierGeschlecht[] = [];

    constructor(
        private api: KieneTableService,
        private messageService: MessageService,
        private localStorageService: LocalStorageService,
        private stammdatenService: StammdatenService,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
    ) {}

    ngOnInit(): void {
        this.itemsPerPage = this.localStorageService.getCurrentUser().elemente_pro_seite;
        this.loadEinstalldaten();
        this.loadGeschlechter();

        if (this.selectedTiere?.length > 0) {
            this.selected = this.selectedTiere;
            this.numberSelected = this.selected.length;
            if (this.anzahlTiereSollwert > 0 && this.selected.length === this.anzahlTiereSollwert) {
                this.selectedAll = true;
            }
        }

        if (this.identifikation && this.selectedTiere?.length > 0) {
            this.showNachladeButton = true;
            this.loadAusgewaehlteTiere();
        } else if (this.selectedTiere?.length > 0) {
            this.tiere = this.selectedTiere;
            this.itemsPerPage = this.tiere.length;
        } else {
            this.loadTiere();
        }

        this.einstalldatumSelectCtrl.valueChanges.subscribe({
            next: einstalldatum => {
                this.einstalldatum = einstalldatum;
                this.reloadTiere();
            },
        });

        this.geschlechtCtrl.valueChanges.pipe(distinctUntilChanged()).subscribe({
            next: () => {
                this.pageIndex = 0;
                this.reloadTiere();
            },
        });

        this.alterTageCtrl.valueChanges.pipe(distinctUntilChanged(), debounceTime(500)).subscribe({
            next: () => {
                this.pageIndex = 0;
                this.reloadTiere();
            },
        });
    }

    ngAfterViewInit() {
        if (this.selectedTiere && this.selectedTiere.length > 0) {
            this.selected = this.selectedTiere;
            this.numberSelected = this.selected?.length;
            if (this.anzahlTiereSollwert > 0 && this.selected?.length === this.anzahlTiereSollwert) {
                this.selectedAll = true;
            }
        }

        this.ohrmarkeCtrl.valueChanges
            .pipe(
                debounceTime(1000),
                distinctUntilChanged(),
                tap(value => {
                    this.pageIndex = 0;
                    this.suchString = value;
                    if (
                        this.identifikation &&
                        this.identifikationErsteSeite.length > 0 &&
                        !this.restlicheGeladen &&
                        !value
                    ) {
                        this.tiere = this.identifikationErsteSeite.slice();
                        this.showNachladeButton = true;
                    } else {
                        this.loadTiere();
                    }
                }),
            )
            .subscribe();
    }

    // tierHinzufuegen(){
    //   const ohrmarke = this.ohrmarkeCtrl.value;
    //   const geburtsdatum = <Date>this.geburtsdatumCtrl.value;

    //   const obj = {
    //     gruppe_id: this.gruppe.gruppe_id,
    //     ohrmarke: ohrmarke,
    //     geburtsdatum: geburtsdatum.toISOString()
    //   };

    //   this.api.create(this.apiBaseUrl + 'gruppe_tier/', obj).subscribe(response => {
    //     this.geburtsdatumCtrl.setValue(null);
    //     this.ohrmarkeCtrl.setValue(null);
    //     // this.loadTiere();
    //     this.messageService.infoMessage('Das Tier wurde erfolgreich der Gruppe hinzugefügt!');
    //   }, error => {
    //     this.messageService.errorMessage('Beim Hinzufügen zur Gruppe ist ein Fehler aufgetreten!', error);
    //   });
    // }

    sortTiere(sort: Sort) {
        this.sortDirection = sort.direction;
        this.sortColumn = sort.active;
        this.reloadTiere();
    }

    /** Bei Identifikation nicht alle Datensätze nachladen: selectedAll heißt nur „Sollzahl erreicht“. */
    private reloadTiere() {
        if (this.identifikation && this.identifikationErsteSeite.length > 0 && !this.restlicheGeladen && !this.suchString) {
            return;
        }
        if (this.selectedAll && !this.identifikation) {
            this.ladeAlleTiere();
        } else {
            this.loadTiere();
        }
    }

    loadEinstalldaten() {
        const params = new HttpParams().set('gruppe_id', this.gruppe?.gruppe_id?.toString());
        this.api.get(this.apiBaseUrl + 'gruppe_tier/read_gruppe_einstalldatum.php', params).subscribe({
            next: response => {
                this.einstalldaten = response.records;
            },
        });
    }

    /** Volle Stammdaten nur für die bereits ausgewählten Tiere (Einstalldatum, Letzte Abgabe, …). */
    private loadAusgewaehlteTiere() {
        const tierIds = (this.selected || [])
            .map(t => Number(t?.tier_id))
            .filter(id => !Number.isNaN(id) && id > 0);
        if (tierIds.length === 0) {
            this.tiere = (this.selected || []).slice();
            this.identifikationErsteSeite = this.tiere.slice();
            return;
        }

        this.isLoading = true;
        let params = this.buildTiereReadParams();
        params = params.set('tier_ids', Array.from(new Set(tierIds)).join(','));
        params = params.set('limit', '10000');
        params = params.set('offset', '0');

        this.api.get(this.apiBaseUrl + 'gruppe_tier/read.php', params).subscribe(
            response => {
                const byKey = new Map<string, GruppeTier>();
                for (const rec of response.records || []) {
                    const key = this.tierKey(rec);
                    if (key && !byKey.has(key)) {
                        byKey.set(key, rec);
                    }
                }
                this.tiere = (this.selected || []).map(s => byKey.get(this.tierKey(s)) ?? s);
                this.identifikationErsteSeite = this.tiere.slice();
                this.selected = this.tiere.slice();
                this.numberSelected = this.selected.length;
                this.isLoading = false;
                this.showNachladeButton = true;
            },
            error => {
                this.tiere = (this.selected || []).slice();
                this.identifikationErsteSeite = this.tiere.slice();
                this.isLoading = false;
                this.messageService.errorMessage(
                    'Die einzelnen Tiere für die Gruppe ' + this.gruppe?.bezeichnung + ' konnten nicht geladen werden!',
                    error,
                );
            },
        );
    }

    loadTiere() {
        this.isLoading = true;
        let params = this.buildTiereReadParams();
        if (this.identifikation) {
            params = params.set('limit', '10000');
            params = params.set('offset', '0');
        } else {
            params = params.set('limit', this.itemsPerPage.toString());
            params = params.set('offset', (this.pageIndex * this.itemsPerPage).toString());
        }

        this.api.get(this.apiBaseUrl + 'gruppe_tier/read.php', params).subscribe(
            response => {
                this.totalRecords = response.count;
                this.tiere = response.records;
                this.isLoading = false;
                if (this.identifikation && this.suchString) {
                    this.showNachladeButton = false;
                }
            },
            error => {
                this.messageService.errorMessage(
                    'Die einzelnen Tiere für die Gruppe ' + this.gruppe?.bezeichnung + ' konnten nicht geladen werden!',
                    error,
                );
                this.isLoading = false;
            },
        );
    }

    ladeAlleTiere() {
        this.isLoading = true;
        let params = this.buildTiereReadParams();
        params = params.set('offset', '0');
        params = params.set('limit', '10000');

        this.api.get(this.apiBaseUrl + 'gruppe_tier/read.php', params).subscribe(
            response => {
                this.totalRecords = response.count;
                this.tiere = response.records;
                this.selected = this.tiere?.slice();
                this.numberSelected = this.selected?.length || 0;
                this.isLoading = false;
                this.selectedAll = true;
                this.showNachladeButton = false;

                const te = new TierauswahlEvent();
                te.tiere = this.selected;
                te.alleSelektiert = this.selectedAll;

                this.selectionChange.emit(te);
            },
            error => {
                this.messageService.errorMessage(
                    'Die einzelnen Tiere für die Gruppe ' + this.gruppe?.bezeichnung + ' konnten nicht geladen werden!',
                    error,
                );
                this.isLoading = false;
                this.selectedAll = false;
            },
        );
    }

    tiereNachladen() {
        this.isLoading = true;
        let params = this.buildTiereReadParams();
        params = params.set('offset', '0');
        params = params.set('limit', '10000');

        this.api.get(this.apiBaseUrl + 'gruppe_tier/read.php', params).subscribe(
            response => {
                this.totalRecords = response.count;
                const vorhanden = new Set(
                    (this.tiere || []).map(t => this.tierKey(t)).filter((key): key is string => !!key),
                );
                const weitere = (response.records || []).filter(t => {
                    const key = this.tierKey(t);
                    return key && !vorhanden.has(key);
                });
                this.tiere = this.tiere.concat(weitere);
                this.isLoading = false;
                this.restlicheGeladen = true;
                this.showNachladeButton = false;
            },
            error => {
                this.messageService.errorMessage(
                    'Die einzelnen Tiere für die Gruppe ' + this.gruppe?.bezeichnung + ' konnten nicht geladen werden!',
                    error,
                );
                this.isLoading = false;
            },
        );
    }

    private buildTiereReadParams(): HttpParams {
        let params = new HttpParams().set('gruppe_id', this.gruppe?.gruppe_id?.toString());
        params = this.appendAbgabebelegStandardParams(params);
        params = params.set('orderby', this.sortColumn + ' ' + this.sortDirection);
        params = params.set('aktuelle', '1');
        if (this.suchString) {
            params = params.set('search', this.suchString);
        }
        if (this.einstalldatum) {
            const d = new Date(this.einstalldatum);
            params = params.set(
                'einstalldatum_notnull',
                d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate(),
            );
        }
        const selectedGeschlechtId = this.geschlechtCtrl.value;
        if (selectedGeschlechtId) {
            params = params.set('geschlecht_id', selectedGeschlechtId.toString());
        }
        const alterTage = this.alterTageCtrl.value;
        if (alterTage && alterTage > 0) {
            params = params.set('alter_max', alterTage.toString());
        }
        return params;
    }

    pageChanged(pe: PageEvent) {
        this.itemsPerPage = pe.pageSize;
        this.pageIndex = pe.pageIndex;
        this.loadTiere();
    }

    private idKey(value: number | string | null | undefined): string | undefined {
        if (value == null || value === '') {
            return undefined;
        }
        return String(value);
    }

    private tierKey(tier: GruppeTier): string | undefined {
        // Abgabebeleg-Tiere haben oft nur tier_id/ohrmarke (Zahl), die Gruppenliste gt_id (String).
        if (this.identifikation) {
            return (
                this.idKey(tier?.tier_id) ??
                this.idKey(tier?.ohrmarke_notnull) ??
                this.idKey(tier?.ohrmarke) ??
                this.idKey(tier?.gt_id)
            );
        }
        return (
            this.idKey(tier?.gt_id) ??
            this.idKey(tier?.tier_id) ??
            this.idKey(tier?.ohrmarke_notnull) ??
            this.idKey(tier?.ohrmarke)
        );
    }

    /** Abgabebeleg-Identifikation: Standardgruppe = alle Tiere des Kunden. */
    private appendAbgabebelegStandardParams(params: HttpParams): HttpParams {
        if (this.identifikation && Number(this.gruppe?.standard) > 0) {
            return params.set('alle_kunden_tiere', '1');
        }
        return params;
    }

    isChecked(tier: GruppeTier): boolean {
        const key = this.tierKey(tier);
        if (!key) {
            return false;
        }
        return !!this.selected?.some(s => this.tierKey(s) === key);
    }

    selectTier(event: MatCheckboxChange, tier: GruppeTier) {
        const key = this.tierKey(tier);

        if (event.checked) {
            if (!this.selected?.some(s => this.tierKey(s) === key)) {
                this.selected?.push(tier);
            }
        } else {
            const index = this.selected?.findIndex(t => this.tierKey(t) === key);
            if (index !== undefined && index > -1) {
                this.selected?.splice(index, 1);
            }
        }

        if (this.selected?.length >= this.anzahlTiereSollwert) {
            this.selectedAll = true;
        } else {
            this.selectedAll = false;
        }

        this.numberSelected = this.selected?.length;
        const te = new TierauswahlEvent();
        te.tiere = this.selected;
        te.alleSelektiert = this.selectedAll;
        this.selectionChange.emit(te);
    }

    /**
     * Kopf-Haken ist an, sobald die wählbare Menge markiert ist.
     * Das ist die Sollzahl oder, wenn weniger Tiere geladen sind, alle geladenen.
     * selectedAll bleibt „Sollzahl erreicht“ und steuert den Text „N Tiere ausgewählt“.
     */
    kopfAuswahlAktiv(): boolean {
        const listed = this.tiere?.length || 0;
        const count = this.selected?.length || 0;
        if (listed === 0 || count === 0) {
            return false;
        }
        const ziel = Math.min(this.selectTarget(), listed);
        if (count < ziel) {
            return false;
        }
        return this.tiere.slice(0, ziel).every(t => this.isChecked(t));
    }

    selectAll(event: MatCheckboxChange) {
        if (!event.checked) {
            this.selected = [];
            this.numberSelected = 0;
            this.selectedAll = false;
            if (!this.identifikation) {
                this.loadTiere();
            }
        } else {
            const target = this.selectTarget();
            const maxSelectable = Math.min(target, this.tiere?.length || 0);
            this.selected = (this.tiere || []).slice(0, maxSelectable);
            this.numberSelected = this.selected.length;
            // Nur true, wenn die Sollzahl (bzw. eine Seite) vollständig erreicht ist.
            this.selectedAll = maxSelectable === target && maxSelectable > 0;
        }

        const te = new TierauswahlEvent();
        te.tiere = this.selected;
        te.alleSelektiert = this.selectedAll;
        this.selectionChange.emit(te);
    }

    /** Sollzahl, sonst eine Seite. Nie mehr, als gerade geladen ist, entscheidet der Aufrufer. */
    private selectTarget(): number {
        if (this.anzahlTiereSollwert > 0) {
            return this.anzahlTiereSollwert;
        }
        return this.itemsPerPage > 0 ? this.itemsPerPage : this.tiere?.length || 0;
    }

    abgang(gt: GruppeTier) {}

    isKaelbermast(): boolean {
        return Number(this.gruppe?.betriebsart_id) === 3033;
    }

    private loadGeschlechter() {
        if (!this.gruppe?.gruppe_id) {
            return;
        }
        this.stammdatenService.ladeGeschlechter(this.gruppe.gruppe_id).subscribe({
            next: result => {
                this.geschlechter = result.records;
            },
            error: err => {
                this.messageService.errorMessage('Die Geschlechter konnten nicht geladen werden!', err);
            },
        });
    }
}
